import { TopRankTemplate } from './TopRankTemplate'
import { withTopRankTemplate } from './withTopRankTemplate'

const ConnectedTopRankTemplate = withTopRankTemplate(TopRankTemplate)

export { ConnectedTopRankTemplate as TopRankTemplate }
